module.exports = __webpack_public_path__ + "static/media/image-card-2.5e9ce70a.png";